<ins-header-nav></ins-header-nav>

<div class="wrapper">
  <ng-container *ngIf="isLoggedIn">
    <nav id="sidebar">
      <ins-left-side-nav></ins-left-side-nav>
    </nav>
  </ng-container>

  <div id="content">
    <router-outlet></router-outlet>
  </div>
</div>

<ins-footer></ins-footer>
